module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "bg-image bg-trees full-height"
  }, [_c('div', {
    class: [_vm.working ? 'block-opt-refresh' : '', 'block', 'block-rounded', 'animated', 'fadeIn', 'centered', 'login']
  }, [_c('div', {
    staticClass: "block-content block-content-full block-content-narrow"
  }, [_c('h1', {
    staticClass: "h2 font-w600 push-10-t push-20 text-center"
  }, [_c('img', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "src": require("../../assets/img/tfs-logo-optimized.jpg")
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal push-30-t push-30",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.attempt($event)
      }
    }
  }, [_c('wc-input', {
    attrs: {
      "label": "Email Address",
      "neverDirty": true
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('wc-input', {
    attrs: {
      "type": "password",
      "label": "Password",
      "neverDirty": true,
      "silent": true
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "css-input switch switch-sm switch-primary"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "remember"
    }
  }), _c('span'), _vm._v(" Remember Me?\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "_token",
      "value": "Gs7rAgsTDA5eqhqQuGz90OR3XiYg4w8t0elDPRqh"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                                Log in\n                            ")])])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dbce98f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/login.vue
// module id = 825
// module chunks = 3